// extracted by mini-css-extract-plugin
export default {"container":"At-z","brandName":"Bt-z","productName":"Ct-z","aboveGalleryInfo":"Dt-z","belowGalleryInfo":"Et-z","breakLongProductName":"Ft-z"};